export default "__VITE_ASSET__BdhDSN8g__"